/*
 * @Description:
 * @Version: 2.0
 * @Autor: qinhao.chang
 * @Date: 2022-02-18 16:29:33
 * @LastEditors: qinhao.chang
 * @LastEditTime: 2022-09-20 16:27:25
 */
// 缩略图组件
import React from "react";
import "./index.scss";
import { adjustRatio } from "@/tools/until";

const Thumbnail = ({ imgArr, width, height }) => {
  return (
    <div className="thumbnail">
      {imgArr.map((v, i) => {
        return (
          <div
            className="pic-box"
            style={{
              width: adjustRatio(width, height)?.width,
              height: adjustRatio(width, height)?.height,
              aspectRatio: adjustRatio(width, height)?.aspectRatio
            }}
            key={i}
          >
            <img src={v} alt="" />
          </div>
        );
      })}
    </div>
  );
};

export default Thumbnail;
